import Vue from 'vue'
import Vuex from 'vuex'
import layout from './modules/layout-module'
import message from './modules/message-module'
import grpr from './modules/grpr-module'
import emitirguia from './modules/EmitirGuia-module'

Vue.config.devtools = true

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    layout,
    message,
    grpr,
    emitirguia
  }
})
